var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageDeliveryPriceIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 482.284,
    height: 315.069,
    viewBox: "0 0 482.284 315.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22383",
    "data-name": "Group 22383",
    transform: "translate(-1189.115 -2510.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22173",
    "data-name": "Path 22173",
    d: "M241.146,2080.2C107.965,2080.2,0,2089.673,0,2101.36s107.965,21.168,241.146,21.168,241.138-9.479,241.138-21.168S374.326,2080.2,241.146,2080.2",
    transform: "translate(1189.115 702.581)",
    fill: "#e3e7ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22363",
    "data-name": "Group 22363",
    transform: "translate(1230.47 2510.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22376",
    "data-name": "Group 22376",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21913",
    "data-name": "Path 21913",
    d: "M1287.222,816.327c-31.252-5.86-59.13-16.85-91.5-31.71-32.367,14.859-60.244,25.849-91.5,31.71,6.379,94,34.254,143.2,91.5,158.089,57.245-14.894,85.118-64.093,91.5-158.089",
    transform: "translate(-884.08 -689.288)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21914",
    "data-name": "Path 21914",
    d: "M1308.979,864.625c-26.761-6.265-51.831-16.238-76.963-27.589-25.13,11.351-50.2,21.323-76.963,27.589,3.76,41.81,13.95,93.5,48.3,119.069a90.116,90.116,0,0,0,28.662,14,90.155,90.155,0,0,0,28.664-14c34.349-25.57,44.539-77.259,48.3-119.069",
    transform: "translate(-920.374 -726.719)",
    fill: "#e3e7ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21915",
    "data-name": "Path 21915",
    d: "M1501.174,864.627c-26.758-6.268-51.831-16.24-76.963-27.591V997.692a90.134,90.134,0,0,0,28.664-14c34.349-25.567,44.539-77.259,48.3-119.066",
    transform: "translate(-1112.569 -726.719)",
    fill: "#00296b",
    fillRule: "evenodd",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21922",
    "data-name": "Path 21922",
    d: "M606.008,920.8a.8.8,0,1,0-.727-1.431l-48.6,24.647a.8.8,0,0,0,.727,1.434Z",
    transform: "translate(-492.787 -785.45)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21923",
    "data-name": "Path 21923",
    d: "M618.808,946.043a.8.8,0,0,0-.727-1.434l-48.6,24.649a.8.8,0,1,0,.726,1.432Z",
    transform: "translate(-501.927 -803.47)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21924",
    "data-name": "Path 21924",
    d: "M631.61,971.286a.8.8,0,0,0-.726-1.434l-48.6,24.649a.8.8,0,0,0,.727,1.432Z",
    transform: "translate(-511.069 -821.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21925",
    "data-name": "Path 21925",
    d: "M644.411,996.527a.8.8,0,0,0-.727-1.431l-48.6,24.647a.8.8,0,0,0,.727,1.434Z",
    transform: "translate(-520.209 -839.52)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21926",
    "data-name": "Path 21926",
    d: "M657.212,1021.765a.8.8,0,1,0-.727-1.434l-48.6,24.647a.8.8,0,1,0,.726,1.434Z",
    transform: "translate(-529.35 -857.54)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21928",
    "data-name": "Path 21928",
    d: "M866.524,820.074a.8.8,0,0,0,.34-1.573l-44.039-9.522a.8.8,0,1,0-.34,1.57Z",
    transform: "translate(-682.448 -706.671)",
    fill: "#d4e4f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21933",
    "data-name": "Path 21933",
    d: "M826.074,973.73a.8.8,0,1,0,.34-1.57l-53.261-11.518a.8.8,0,0,0-.34,1.571Z",
    transform: "translate(-646.979 -814.968)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21934",
    "data-name": "Path 21934",
    d: "M820.091,1001.392a.8.8,0,0,0,.339-1.57L767.17,988.3a.8.8,0,0,0-.34,1.571Z",
    transform: "translate(-642.707 -834.72)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21935",
    "data-name": "Path 21935",
    d: "M814.11,1029.052a.8.8,0,0,0,.34-1.57l-53.261-11.517a.8.8,0,1,0-.339,1.57Z",
    transform: "translate(-638.435 -854.471)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21936",
    "data-name": "Path 21936",
    d: "M808.13,1056.714a.8.8,0,1,0,.339-1.57l-53.26-11.518a.8.8,0,0,0-.34,1.571Z",
    transform: "translate(-634.166 -874.223)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21937",
    "data-name": "Path 21937",
    d: "M802.148,1084.375a.8.8,0,1,0,.339-1.57l-53.26-11.518a.8.8,0,0,0-.34,1.571Z",
    transform: "translate(-629.894 -893.975)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21938",
    "data-name": "Path 21938",
    d: "M666.406,657.082l66.306,15.058,14.578,2.877L745,686.83,720.232,795.9l-81.165-18.433Z",
    transform: "translate(-551.929 -598.221)",
    fill: "#d4e4f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21939",
    "data-name": "Path 21939",
    d: "M778.709,753.782a.8.8,0,1,1,.356-1.568L823,762.191a.8.8,0,0,1-.356,1.568Z",
    transform: "translate(-651.194 -666.136)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21940",
    "data-name": "Path 21940",
    d: "M752.538,794.529a.8.8,0,1,1,.356-1.568l53.138,12.068a.8.8,0,1,1-.356,1.566Z",
    transform: "translate(-632.506 -695.232)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21941",
    "data-name": "Path 21941",
    d: "M746.271,822.126a.8.8,0,0,1,.356-1.568l53.138,12.068a.8.8,0,1,1-.356,1.568Z",
    transform: "translate(-628.033 -714.938)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21942",
    "data-name": "Path 21942",
    d: "M740.005,849.725a.8.8,0,0,1,.355-1.568L793.5,860.225a.8.8,0,0,1-.356,1.568Z",
    transform: "translate(-623.558 -734.645)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21943",
    "data-name": "Path 21943",
    d: "M733.736,877.325a.8.8,0,1,1,.355-1.566l53.139,12.065a.8.8,0,0,1-.356,1.568Z",
    transform: "translate(-619.081 -754.354)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21944",
    "data-name": "Path 21944",
    d: "M727.469,904.924a.8.8,0,1,1,.356-1.568l53.139,12.065a.8.8,0,0,1-.356,1.568Z",
    transform: "translate(-614.606 -774.061)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21945",
    "data-name": "Path 21945",
    d: "M721.2,932.521a.8.8,0,1,1,.356-1.567l53.137,12.068a.8.8,0,1,1-.355,1.566Z",
    transform: "translate(-610.13 -793.767)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21946",
    "data-name": "Path 21946",
    d: "M714.934,960.118a.8.8,0,1,1,.355-1.568l53.138,12.068a.8.8,0,0,1-.355,1.568Z",
    transform: "translate(-605.655 -813.472)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21947",
    "data-name": "Path 21947",
    d: "M708.667,987.715a.8.8,0,0,1,.355-1.568l53.139,12.068a.8.8,0,1,1-.355,1.568Z",
    transform: "translate(-601.181 -833.178)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21948",
    "data-name": "Path 21948",
    d: "M702.4,1015.314a.8.8,0,1,1,.356-1.568l53.139,12.068a.8.8,0,0,1-.356,1.568Z",
    transform: "translate(-596.704 -852.886)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21949",
    "data-name": "Path 21949",
    d: "M752.556,816.068a1.439,1.439,0,0,1,1.723-1.963c.362-.6.941-1.728,1.551-2.921.659-1.288,1.354-2.646,2.027-3.691.944-1.469,1.658-2.628,2.268-3.618,2.376-3.858,3.643-5.918,5.466-4.505,1.172.906,1.273,4.253,1.48,11.42l.076,2.581c.132,4.422-.982,6.235-.47,6.219.356-.009.284-1.32,1.3-3.418a95.429,95.429,0,0,1,7.155-12.78c3.581-5.243,5.577-7.084,7.122-6.032,1.314.9,1.141,3.726.864,8.261-.141,2.292-.311,5.081-.383,8.3,1.108-1.774,2.694-4.371,3.684-5.993.331-.543.591-.967.828-1.339l0,0c.494-.779,2-3.3,3.588-5.948l2.192-3.661c-.352.143-.714.3-1.08.467a1.441,1.441,0,0,1-1.206-2.618c.742-.34,1.429-.61,2.084-.867a14.166,14.166,0,0,0,3.428-1.714,1.439,1.439,0,0,1,2.077,1.915,7.012,7.012,0,0,0-.159,1.538,25.255,25.255,0,0,0,.11,3.545,1.382,1.382,0,0,1,0,.328l0,.116a1.438,1.438,0,0,1-2.875-.079l0-.1c-.027-.226-.05-.5-.069-.8l-2.037,3.4c-1.669,2.789-3.262,5.451-3.62,6.015l0,0v0c-.122.19-.427.692-.8,1.3-1.9,3.115-5.678,9.3-7.394,9.3-1.065,0-1.664-.588-1.664-1.9,0-4.438.239-8.33.426-11.369.216-3.534.423-5.689.389-5.715-.248-.169-.686,1.714-3.122,5.278a93.188,93.188,0,0,0-6.94,12.408c-1.48,3.062-2.42,5-3.814,5.042-1.725.051-2.29-2.537-2.484-9.015l-.077-2.581c-.18-6.235-.265-9.147-.364-9.223-.709-.548.022,1.658-1.259,3.74-.683,1.108-1.478,2.4-2.291,3.663-.642,1-1.285,2.253-1.893,3.441-1.122,2.188-2.152,4.2-3.284,4.7-1.1.486-1.966.194-2.549-1.124",
    transform: "translate(-632.88 -694.534)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21950",
    "data-name": "Path 21950",
    d: "M505.923,949.591l6.979,162.076,176.811-18.613-20.94-143.464H651.7l-8.1,12.366H536.149l-11.086-12.366Z",
    transform: "translate(-456.856 -807.09)",
    fill: "#f6d7bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21951",
    "data-name": "Path 21951",
    d: "M427.262,1091.207c14.242,5.238,22.485,12.4,29.471,19.971L449.754,949.1l-7.95-.2Z",
    transform: "translate(-400.687 -806.599)",
    fill: "#e5bb9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21954",
    "data-name": "Path 21954",
    d: "M373.841,981.358l-6.55,64.095q-7.936-.208-32.967.652c4.132-31.467,9.174-53.41,15.887-64.747,4.027-6.8,8.654-9.787,14.048-8.724,3.042.6,6.33,2.489,9.889,5.708Z",
    transform: "translate(-334.324 -823.394)",
    fill: "#bf9071",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21960",
    "data-name": "Path 21960",
    d: "M1114.8,1379.063c-13.728,7.928-36,7.928-49.732,0-6.455-3.726-9.876-8.543-10.264-13.425-.022-.294-.031-9.61-.036-9.9-.018-5.213,3.413-1.4,10.3-5.382,13.737-7.933,36-7.933,49.732,0,6.822,3.941,10.259.074,10.3,5.236,0,.291,0,9.6-.023,9.889-.323,4.938-3.749,9.82-10.278,13.585",
    transform: "translate(-848.763 -1089.009)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21961",
    "data-name": "Path 21961",
    d: "M1055.192,1376.282a.576.576,0,0,1,.243.47v14.667a12.343,12.343,0,0,1-.632-3.018c-.022-.294-.031-9.61-.036-9.9a4.169,4.169,0,0,1,.425-2.216",
    transform: "translate(-848.763 -1111.773)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21962",
    "data-name": "Path 21962",
    d: "M1060.926,1382.579v16.649a15.56,15.56,0,0,1-1.181-1.952v-14.7a.587.587,0,0,1,.586-.587l.053,0a.589.589,0,0,1,.542.583",
    transform: "translate(-852.318 -1115.85)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21963",
    "data-name": "Path 21963",
    d: "M1067.657,1388.692v16.961a.568.568,0,0,1-.037.2q-.619-.638-1.154-1.293v-15.872a.593.593,0,0,1,.586-.592l.06,0a.591.591,0,0,1,.545.588",
    transform: "translate(-857.117 -1120.211)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21964",
    "data-name": "Path 21964",
    d: "M1074.386,1394.794v16.955a.6.6,0,0,1-.044.222c-.408-.333-.8-.673-1.166-1.015v-16.161a.6.6,0,0,1,.595-.6l.055.007a.6.6,0,0,1,.56.59",
    transform: "translate(-861.909 -1124.565)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21965",
    "data-name": "Path 21965",
    d: "M1081.12,1400.917v16.895q-.634-.43-1.223-.875v-16.02a.6.6,0,0,1,.6-.6h.059a.606.606,0,0,1,.568.6",
    transform: "translate(-866.708 -1128.937)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21966",
    "data-name": "Path 21966",
    d: "M1087.859,1407.026v16.354l-.045-.028q-.614-.354-1.191-.722v-15.6a.6.6,0,0,1,.6-.6h.055a.612.612,0,0,1,.582.6",
    transform: "translate(-871.511 -1133.298)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21967",
    "data-name": "Path 21967",
    d: "M1094.579,1413.138v15.634q-.636-.316-1.251-.652v-14.982a.607.607,0,0,1,.606-.6h.059a.61.61,0,0,1,.586.6",
    transform: "translate(-876.298 -1137.659)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21968",
    "data-name": "Path 21968",
    d: "M1101.315,1419.249v14.776q-.638-.274-1.263-.567v-14.209a.607.607,0,0,1,.606-.608h.058a.616.616,0,0,1,.6.608",
    transform: "translate(-881.1 -1142.019)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21969",
    "data-name": "Path 21969",
    d: "M1106.766,1438.653v-13.3a.617.617,0,0,1,.61-.613h.06a.613.613,0,0,1,.61.613v13.8q-.648-.243-1.281-.5",
    transform: "translate(-885.894 -1146.374)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21970",
    "data-name": "Path 21970",
    d: "M1115.4,1440.484v-13.862a.615.615,0,0,1,.611-.613h.065a.617.617,0,0,1,.613.613V1440.9c-.433-.134-.863-.271-1.288-.417",
    transform: "translate(-892.062 -1147.281)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21971",
    "data-name": "Path 21971",
    d: "M1124.042,1442.155v-14.26a.617.617,0,0,1,.613-.615h.069a.617.617,0,0,1,.613.615V1442.5c-.435-.111-.865-.227-1.3-.347",
    transform: "translate(-898.23 -1148.188)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21972",
    "data-name": "Path 21972",
    d: "M1132.689,1443.692v-14.517a.617.617,0,0,1,.613-.617h.074a.617.617,0,0,1,.613.617v14.8c-.435-.085-.867-.18-1.3-.28",
    transform: "translate(-904.404 -1149.1)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21973",
    "data-name": "Path 21973",
    d: "M1141.319,1445.1v-14.653a.622.622,0,0,1,.62-.617h.072a.622.622,0,0,1,.618.617v14.874c-.437-.067-.874-.142-1.309-.22",
    transform: "translate(-910.567 -1150.007)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21974",
    "data-name": "Path 21974",
    d: "M1149.957,1446.39v-14.672a.625.625,0,0,1,.62-.622h.079a.623.623,0,0,1,.619.622v14.832c-.444-.047-.881-.1-1.318-.16",
    transform: "translate(-916.735 -1150.913)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21975",
    "data-name": "Path 21975",
    d: "M1158.6,1447.572v-14.584a.623.623,0,0,1,.62-.622h.085a.623.623,0,0,1,.617.622v14.691c-.439-.03-.881-.064-1.323-.106",
    transform: "translate(-922.903 -1151.82)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21976",
    "data-name": "Path 21976",
    d: "M1167.233,1448.653V1434.26a.626.626,0,0,1,.622-.624h.086a.625.625,0,0,1,.624.624V1448.7c-.444-.012-.891-.031-1.332-.051",
    transform: "translate(-929.071 -1152.727)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21977",
    "data-name": "Path 21977",
    d: "M1175.879,1449.637v-14.1a.628.628,0,0,1,.622-.627h.092a.626.626,0,0,1,.62.627v14.094c-.444.007-.891.007-1.334,0",
    transform: "translate(-935.245 -1153.64)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21978",
    "data-name": "Path 21978",
    d: "M1184.671,1448.672v-14.443a.621.621,0,0,1,.62-.624h.088a.624.624,0,0,1,.624.624v14.385c-.444.025-.888.044-1.332.058",
    transform: "translate(-941.523 -1152.704)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21979",
    "data-name": "Path 21979",
    d: "M1193.455,1447.6V1432.91a.624.624,0,0,1,.618-.625h.088a.624.624,0,0,1,.618.625v14.575c-.439.043-.879.078-1.323.113",
    transform: "translate(-947.795 -1151.762)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21980",
    "data-name": "Path 21980",
    d: "M1202.255,1446.416v-14.824a.621.621,0,0,1,.615-.624h.079a.626.626,0,0,1,.622.624v14.656c-.437.063-.877.118-1.316.169",
    transform: "translate(-954.079 -1150.821)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21981",
    "data-name": "Path 21981",
    d: "M1211.039,1445.137V1430.28a.618.618,0,0,1,.617-.615h.072a.619.619,0,0,1,.62.615v14.63c-.434.081-.869.155-1.309.227",
    transform: "translate(-960.351 -1149.891)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21982",
    "data-name": "Path 21982",
    d: "M1219.831,1443.73v-14.769a.616.616,0,0,1,.613-.615h.072a.619.619,0,0,1,.615.615v14.478c-.43.1-.865.2-1.3.292",
    transform: "translate(-966.629 -1148.949)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21983",
    "data-name": "Path 21983",
    d: "M1228.623,1442.2V1427.64a.615.615,0,0,1,.61-.613h.069a.617.617,0,0,1,.615.613v14.2c-.43.125-.86.243-1.295.359",
    transform: "translate(-972.907 -1148.008)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21984",
    "data-name": "Path 21984",
    d: "M1237.406,1440.537v-14.2a.614.614,0,0,1,.615-.608h.063a.609.609,0,0,1,.608.608V1440.1q-.635.226-1.286.435",
    transform: "translate(-979.179 -1147.078)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21985",
    "data-name": "Path 21985",
    d: "M1246.207,1438.7V1425.01a.607.607,0,0,1,.606-.611h.06a.614.614,0,0,1,.615.611v13.171c-.423.18-.851.351-1.281.52",
    transform: "translate(-985.463 -1146.131)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21986",
    "data-name": "Path 21986",
    d: "M1253.76,1419.37v13.969q-.624.305-1.27.592V1419.37a.612.612,0,0,1,.608-.608h.06a.62.62,0,0,1,.6.608",
    transform: "translate(-989.95 -1142.106)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21987",
    "data-name": "Path 21987",
    d: "M1260.056,1413.723v14.656q-.614.34-1.249.664v-15.32a.607.607,0,0,1,.6-.606h.058a.617.617,0,0,1,.588.606",
    transform: "translate(-994.46 -1138.075)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21988",
    "data-name": "Path 21988",
    d: "M1266.335,1408.077v15.206q-.6.385-1.235.756v-15.962a.605.605,0,0,1,.6-.6l.058.005a.6.6,0,0,1,.576.594",
    transform: "translate(-998.954 -1134.048)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21989",
    "data-name": "Path 21989",
    d: "M1272.629,1402.446v15.567c-.388.3-.8.59-1.221.874v-16.441a.6.6,0,0,1,.6-.6h.058a.605.605,0,0,1,.566.6",
    transform: "translate(-1003.458 -1130.029)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21990",
    "data-name": "Path 21990",
    d: "M1278.911,1396.8v15.7c-.381.352-.786.7-1.209,1.036V1396.8a.594.594,0,0,1,.6-.592h.056a.6.6,0,0,1,.557.592",
    transform: "translate(-1007.952 -1125.998)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21991",
    "data-name": "Path 21991",
    d: "M1285.209,1391.156v15.465c-.37.433-.768.863-1.191,1.281v-16.747a.587.587,0,0,1,.585-.59h.06a.591.591,0,0,1,.546.59",
    transform: "translate(-1012.463 -1121.972)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21992",
    "data-name": "Path 21992",
    d: "M1291.489,1385.506v14.57a16.439,16.439,0,0,1-1.177,1.76v-16.33a.587.587,0,0,1,.585-.585l.055,0a.586.586,0,0,1,.537.58",
    transform: "translate(-1016.956 -1117.942)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21993",
    "data-name": "Path 21993",
    d: "M1296.6,1394.843v-14.984a.584.584,0,0,1,1.14-.176c.011.109.021.224.028.347v9.494c0,.49,0,.807-.009.856a12.589,12.589,0,0,1-1.159,4.463",
    transform: "translate(-1021.45 -1113.91)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21994",
    "data-name": "Path 21994",
    d: "M1114.8,1347.517c-13.728,7.93-36,7.93-49.732,0s-13.732-20.787,0-28.713,36-7.93,49.732,0,13.737,20.784,0,28.713",
    transform: "translate(-848.765 -1066.483)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21995",
    "data-name": "Path 21995",
    d: "M1117.827,1349.263c-13.072,7.548-34.266,7.548-47.344,0s-13.072-19.786,0-27.33,34.272-7.551,47.344,0,13.072,19.783,0,27.33",
    transform: "translate(-852.985 -1068.92)",
    fill: "#deecf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21996",
    "data-name": "Path 21996",
    d: "M1128.121,1355.213c-10.826,6.25-28.385,6.25-39.212,0s-10.831-16.39,0-22.639,28.382-6.249,39.212,0,10.826,16.388,0,22.639",
    transform: "translate(-867.342 -1077.216)",
    fill: "#e68724",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21997",
    "data-name": "Path 21997",
    d: "M1128.2,1337.653c-10.83-6.249-28.384-6.249-39.212,0-5.095,2.942-7.789,6.742-8.09,10.592.3,3.853,3,7.653,8.09,10.595,10.828,6.249,28.386,6.249,39.212,0,5.09-2.942,7.792-6.741,8.09-10.59-.3-3.856-3-7.655-8.09-10.6",
    transform: "translate(-867.424 -1080.843)",
    fill: "#f89a1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21998",
    "data-name": "Path 21998",
    d: "M1119.434,1366.451l5.213-3.011c1.864,2.283-1.85,4.174-5.213,3.011m13.937-11.869-4.931,2.849c-1.573-1.9,1.423-3.839,4.931-2.849m6.621-3.777-1.163.673c-10.005-5.25-24.242,1.691-16.307,9.366l-6.737,3.89a6.668,6.668,0,0,1-1.931-2.581c-.46-1.154-2.3-1.945-4.346-1.813-1.968.127-3.437.432-3.557,1.5a4.522,4.522,0,0,0,.12,1.344,10.9,10.9,0,0,0,4.5,4.561l-1.337-.19c-.25.143-.146,1.165-.146,1.353a.63.63,0,0,0,.372.523l1.462.844a2.008,2.008,0,0,0,1.808,0l1.15-.664c5.678,2.278,11.422,2.274,15.867-.289q6.294-3.636.981-9.39l5.8-3.346a4,4,0,0,1,.722,1.149c.5,1.14,2.382,1.9,4.4,1.765,2.613-.164,4.378-1.834,3.488-3.258a10.353,10.353,0,0,0-3.016-2.819l1.2-.7a.561.561,0,0,0,.34-.49c0-.167.132-1.217-.09-1.346l-1.929-.086a1.817,1.817,0,0,0-1.649,0",
    transform: "translate(-885.305 -1092.753)",
    fill: "#e68724",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21999",
    "data-name": "Path 21999",
    d: "M1119.429,1362.634l5.213-3.009c1.864,2.283-1.85,4.172-5.213,3.009m13.937-11.869-4.931,2.852c-1.573-1.906,1.422-3.842,4.931-2.852m6.621-3.774-1.163.671c-10.005-5.25-24.242,1.69-16.307,9.369l-6.737,3.89a6.669,6.669,0,0,1-1.931-2.581c-.46-1.154-2.3-1.95-4.346-1.818-2.4.16-4.059,1.5-3.437,2.849a10.891,10.891,0,0,0,4.5,4.558l-1.11.641a.552.552,0,0,0,0,1.045l1.462.847a2.025,2.025,0,0,0,1.808,0l1.15-.664c5.678,2.275,11.422,2.271,15.867-.291q6.294-3.632.981-9.39l5.8-3.347a4.026,4.026,0,0,1,.722,1.15c.5,1.143,2.382,1.892,4.4,1.765,2.614-.164,4.311-1.7,3.418-3.127a10.323,10.323,0,0,0-2.946-2.949l1.2-.7a.5.5,0,0,0,0-.955l-1.679-.967a1.818,1.818,0,0,0-1.649,0",
    transform: "translate(-885.3 -1090.028)",
    fill: "#fbb031",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22000",
    "data-name": "Path 22000",
    d: "M1107.98,1335.556c-13.735,7.93-36,7.93-49.732,0-6.459-3.728-9.878-8.546-10.264-13.428-.022-.3-.036-9.607-.036-9.9-.023-5.208,3.409-1.4,10.3-5.382,13.729-7.926,36-7.926,49.732,0,6.822,3.941,10.254.076,10.3,5.24,0,.287-.009,9.6-.028,9.887-.317,4.936-3.745,9.815-10.273,13.585",
    transform: "translate(-843.895 -1057.945)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22001",
    "data-name": "Path 22001",
    d: "M1048.373,1332.76a.584.584,0,0,1,.24.47v14.656a12.261,12.261,0,0,1-.628-3.006c-.022-.292-.036-9.607-.036-9.9a4.151,4.151,0,0,1,.424-2.216",
    transform: "translate(-843.895 -1080.695)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22002",
    "data-name": "Path 22002",
    d: "M1054.1,1339.058V1355.7a15.8,15.8,0,0,1-1.178-1.948v-14.7a.589.589,0,0,1,.588-.588l.054.005a.589.589,0,0,1,.536.583",
    transform: "translate(-847.447 -1084.773)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22003",
    "data-name": "Path 22003",
    d: "M1060.828,1345.167v16.964a.585.585,0,0,1-.037.206q-.623-.642-1.159-1.3v-15.87a.6.6,0,0,1,.591-.59l.055,0a.593.593,0,0,1,.549.585",
    transform: "translate(-852.237 -1089.133)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22004",
    "data-name": "Path 22004",
    d: "M1067.567,1351.289v16.955a.574.574,0,0,1-.045.222c-.408-.331-.8-.671-1.164-1.013v-16.164a.592.592,0,0,1,.591-.59h.059a.6.6,0,0,1,.56.59",
    transform: "translate(-857.039 -1093.505)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22005",
    "data-name": "Path 22005",
    d: "M1074.3,1357.395v16.892q-.633-.427-1.218-.869v-16.023a.6.6,0,0,1,.594-.6h.054a.6.6,0,0,1,.569.6",
    transform: "translate(-861.842 -1097.86)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22006",
    "data-name": "Path 22006",
    d: "M1081.024,1363.5v16.351l-.041-.023c-.41-.238-.809-.478-1.2-.726v-15.6a.6.6,0,0,1,.6-.6h.059a.611.611,0,0,1,.577.6",
    transform: "translate(-866.63 -1102.22)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22007",
    "data-name": "Path 22007",
    d: "M1087.763,1369.615v15.637q-.635-.316-1.25-.653v-14.984a.6.6,0,0,1,.6-.6h.06a.617.617,0,0,1,.591.6",
    transform: "translate(-871.432 -1106.581)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22008",
    "data-name": "Path 22008",
    d: "M1094.487,1375.72V1390.5q-.644-.278-1.269-.571V1375.72a.61.61,0,0,1,.608-.611h.06a.624.624,0,0,1,.6.611",
    transform: "translate(-876.22 -1110.935)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22009",
    "data-name": "Path 22009",
    d: "M1099.94,1395.132v-13.3a.613.613,0,0,1,.61-.613h.058a.617.617,0,0,1,.615.613v13.8q-.649-.239-1.283-.5",
    transform: "translate(-881.02 -1115.296)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22010",
    "data-name": "Path 22010",
    d: "M1108.578,1396.975v-13.863a.614.614,0,0,1,.613-.611h.065a.614.614,0,0,1,.613.611v14.279q-.653-.2-1.291-.416",
    transform: "translate(-887.188 -1116.214)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22011",
    "data-name": "Path 22011",
    d: "M1117.224,1398.651v-14.258a.61.61,0,0,1,.613-.613h.069a.611.611,0,0,1,.613.613V1399c-.435-.111-.867-.227-1.295-.347",
    transform: "translate(-893.362 -1117.127)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22012",
    "data-name": "Path 22012",
    d: "M1125.854,1400.177v-14.519a.619.619,0,0,1,.617-.615h.069a.619.619,0,0,1,.618.615v14.8c-.437-.088-.872-.183-1.3-.282",
    transform: "translate(-899.524 -1118.028)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22013",
    "data-name": "Path 22013",
    d: "M1134.5,1401.589v-14.656a.617.617,0,0,1,.613-.613h.078a.617.617,0,0,1,.618.613v14.878q-.656-.1-1.309-.222",
    transform: "translate(-905.698 -1118.94)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22014",
    "data-name": "Path 22014",
    d: "M1143.13,1402.882v-14.674a.619.619,0,0,1,.62-.618h.081a.622.622,0,0,1,.617.618v14.836c-.439-.049-.879-.1-1.318-.162",
    transform: "translate(-911.86 -1119.847)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22015",
    "data-name": "Path 22015",
    d: "M1151.769,1404.063v-14.584a.622.622,0,0,1,.622-.62h.08a.622.622,0,0,1,.622.62v14.693c-.442-.032-.886-.067-1.325-.109",
    transform: "translate(-918.029 -1120.753)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22016",
    "data-name": "Path 22016",
    d: "M1160.407,1405.15v-14.39a.625.625,0,0,1,.625-.622h.085a.624.624,0,0,1,.622.622V1405.2c-.444-.014-.888-.03-1.332-.054",
    transform: "translate(-924.197 -1121.667)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22017",
    "data-name": "Path 22017",
    d: "M1169.044,1406.129v-14.1a.626.626,0,0,1,.625-.622h.088a.627.627,0,0,1,.629.622v14.1c-.448.007-.895.007-1.342,0",
    transform: "translate(-930.364 -1122.573)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22018",
    "data-name": "Path 22018",
    d: "M1177.829,1405.159v-14.448a.627.627,0,0,1,.622-.622h.088a.624.624,0,0,1,.622.622v14.39c-.444.026-.888.042-1.332.058",
    transform: "translate(-936.637 -1121.632)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22019",
    "data-name": "Path 22019",
    d: "M1186.621,1404.083v-14.691a.625.625,0,0,1,.622-.622h.083a.626.626,0,0,1,.622.622v14.58q-.663.062-1.328.111",
    transform: "translate(-942.915 -1120.69)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22020",
    "data-name": "Path 22020",
    d: "M1195.413,1402.908v-14.829a.623.623,0,0,1,.625-.618h.076a.619.619,0,0,1,.618.618v14.662q-.659.09-1.318.167",
    transform: "translate(-949.193 -1119.755)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22021",
    "data-name": "Path 22021",
    d: "M1204.2,1401.617v-14.855a.621.621,0,0,1,.617-.62h.079a.621.621,0,0,1,.615.62v14.628c-.435.081-.872.155-1.311.227",
    transform: "translate(-955.471 -1118.813)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22022",
    "data-name": "Path 22022",
    d: "M1213,1400.21v-14.769a.618.618,0,0,1,.618-.618h.072a.618.618,0,0,1,.615.618v14.477c-.432.1-.869.2-1.3.292",
    transform: "translate(-961.749 -1117.871)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22023",
    "data-name": "Path 22023",
    d: "M1221.8,1398.687v-14.552a.611.611,0,0,1,.615-.613h.062a.611.611,0,0,1,.613.613v14.2q-.639.188-1.29.356",
    transform: "translate(-968.032 -1116.942)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22024",
    "data-name": "Path 22024",
    d: "M1230.6,1397.016v-14.2a.609.609,0,0,1,.608-.613h.063a.613.613,0,0,1,.613.613v13.766c-.423.15-.854.3-1.283.435",
    transform: "translate(-974.316 -1116)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22025",
    "data-name": "Path 22025",
    d: "M1239.379,1395.185v-13.692a.613.613,0,0,1,.611-.608h.058a.612.612,0,0,1,.608.608v13.173q-.631.267-1.277.518",
    transform: "translate(-980.588 -1115.059)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22026",
    "data-name": "Path 22026",
    d: "M1246.94,1375.85v13.969c-.417.2-.837.4-1.268.59V1375.85a.61.61,0,0,1,.611-.611h.057a.624.624,0,0,1,.6.611",
    transform: "translate(-985.081 -1111.028)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22027",
    "data-name": "Path 22027",
    d: "M1253.221,1370.211v14.656q-.617.344-1.256.666v-15.322a.6.6,0,0,1,.606-.6h.06a.61.61,0,0,1,.59.6",
    transform: "translate(-989.575 -1107.008)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22028",
    "data-name": "Path 22028",
    d: "M1259.517,1364.566v15.2c-.4.259-.812.511-1.235.759v-15.958a.6.6,0,0,1,.6-.6h.06a.609.609,0,0,1,.576.6",
    transform: "translate(-994.086 -1102.977)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22029",
    "data-name": "Path 22029",
    d: "M1265.8,1358.921V1374.5q-.59.444-1.223.874v-16.448a.6.6,0,0,1,.594-.594h.06a.6.6,0,0,1,.569.594",
    transform: "translate(-998.579 -1098.952)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22030",
    "data-name": "Path 22030",
    d: "M1272.088,1353.273v15.7c-.382.349-.782.694-1.2,1.031v-16.735a.593.593,0,0,1,.59-.592h.06a.6.6,0,0,1,.555.592",
    transform: "translate(-1003.083 -1094.92)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22031",
    "data-name": "Path 22031",
    d: "M1278.377,1347.634V1363.1c-.37.435-.768.865-1.193,1.286v-16.751a.592.592,0,0,1,.59-.59l.056,0a.59.59,0,0,1,.548.585",
    transform: "translate(-1007.583 -1090.895)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22032",
    "data-name": "Path 22032",
    d: "M1284.668,1341.985v14.568a16.539,16.539,0,0,1-1.175,1.76v-16.328a.586.586,0,0,1,.58-.587l.06,0a.588.588,0,0,1,.534.583",
    transform: "translate(-1012.088 -1086.864)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22033",
    "data-name": "Path 22033",
    d: "M1289.786,1351.329v-14.977a.582.582,0,0,1,1.14-.166c.009.092.016.189.023.289v9.422c0,.555-.007.918-.009.974a12.512,12.512,0,0,1-1.154,4.459",
    transform: "translate(-1016.581 -1082.844)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22034",
    "data-name": "Path 22034",
    d: "M1107.974,1304c-13.736,7.933-36,7.933-49.732,0s-13.736-20.78,0-28.71,36-7.928,49.732,0,13.731,20.784,0,28.71",
    transform: "translate(-843.888 -1035.41)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22035",
    "data-name": "Path 22035",
    d: "M1111.006,1305.75c-13.072,7.544-34.27,7.544-47.342,0s-13.072-19.785,0-27.334,34.266-7.546,47.342,0,13.074,19.786,0,27.334",
    transform: "translate(-848.116 -1037.848)",
    fill: "#deecf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22036",
    "data-name": "Path 22036",
    d: "M1121.294,1311.687c-10.828,6.254-28.38,6.254-39.213,0s-10.826-16.386,0-22.64,28.385-6.251,39.213,0,10.831,16.39,0,22.64",
    transform: "translate(-862.47 -1046.134)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22037",
    "data-name": "Path 22037",
    d: "M1121.368,1294.145c-10.828-6.254-28.386-6.254-39.213,0-5.09,2.942-7.791,6.739-8.09,10.595.3,3.848,3,7.648,8.09,10.59,10.833,6.254,28.385,6.254,39.213,0,5.095-2.942,7.789-6.742,8.095-10.59-.305-3.851-3-7.65-8.095-10.59",
    transform: "translate(-862.544 -1049.773)",
    fill: "#bcdbf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22038",
    "data-name": "Path 22038",
    d: "M1112.608,1322.932l5.213-3.011c1.864,2.28-1.848,4.172-5.213,3.011m13.939-11.871-4.938,2.852c-1.568-1.906,1.425-3.837,4.938-2.852m6.617-3.772-1.161.668c-10-5.25-24.242,1.691-16.3,9.369l-6.741,3.89a6.7,6.7,0,0,1-1.931-2.577c-.456-1.161-2.3-1.952-4.345-1.818-1.964.125-3.437.43-3.555,1.5a4.35,4.35,0,0,0,.123,1.341,10.887,10.887,0,0,0,4.494,4.563l-1.332-.2c-.252.146-.153,1.168-.153,1.36a.646.646,0,0,0,.38.523l1.457.842a2.022,2.022,0,0,0,1.808,0l1.152-.666c5.675,2.278,11.42,2.278,15.86-.289q6.3-3.636.983-9.392l5.8-3.344a4.22,4.22,0,0,1,.724,1.154c.5,1.138,2.378,1.891,4.4,1.765,2.618-.169,4.38-1.832,3.49-3.266a10.512,10.512,0,0,0-3.018-2.817l1.2-.7a.56.56,0,0,0,.34-.49c-.009-.169.127-1.214-.09-1.339l-1.926-.088a1.831,1.831,0,0,0-1.656,0",
    transform: "translate(-880.432 -1061.677)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22039",
    "data-name": "Path 22039",
    d: "M1112.605,1319.117l5.213-3.009c1.864,2.28-1.848,4.172-5.213,3.009m13.939-11.866-4.937,2.849c-1.568-1.906,1.424-3.834,4.938-2.849m6.617-3.779-1.161.675c-10-5.25-24.242,1.689-16.3,9.367l-6.742,3.89a6.684,6.684,0,0,1-1.931-2.576c-.456-1.161-2.3-1.952-4.346-1.818-2.4.153-4.058,1.5-3.432,2.845a10.9,10.9,0,0,0,4.494,4.563l-1.105.64a.551.551,0,0,0,0,1.046l1.457.842a2.011,2.011,0,0,0,1.808,0l1.152-.664c5.675,2.275,11.42,2.273,15.861-.292q6.3-3.632.983-9.39l5.8-3.346a4.246,4.246,0,0,1,.724,1.151c.5,1.14,2.378,1.894,4.4,1.767,2.618-.169,4.306-1.7,3.418-3.131a10.537,10.537,0,0,0-2.946-2.951l1.2-.693a.5.5,0,0,0,0-.951l-1.677-.973a1.833,1.833,0,0,0-1.656,0",
    transform: "translate(-880.429 -1058.955)",
    fill: "#deecf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22040",
    "data-name": "Path 22040",
    d: "M448.6,957.432a.318.318,0,0,0-.636,0q-.255,26.011-.479,46.96c-.552,53.093-.852,82.088-.348,88.663-4.1-1.638-9.292-.99-15.875,1.723a.318.318,0,1,0,.242.588c6.676-2.752,11.855-3.34,15.862-1.522l.013.007a10.959,10.959,0,0,1,1.556.867c4.214,2.826,7.01,8.844,8.862,18.4a.318.318,0,0,0,.625-.12c-1.885-9.732-4.765-15.881-9.134-18.809a11.306,11.306,0,0,0-1.488-.847c-.541-5.787-.239-34.855.322-88.948q.218-20.96.479-46.96",
    transform: "translate(-403.404 -812.461)",
    fill: "#bf9071",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22045",
    "data-name": "Path 22045",
    d: "M1663.081,500.826c-28,7.5-48.441,42.048-38.672,82.967,11.679,8.259,22.933,13.315,32.7,15.962-15.421-32.422-1.151-62.3,21.185-67.129-5.943-7.56-11.506-18.143-15.21-31.8",
    transform: "translate(-1253.755 -486.645)",
    fill: "#a4ccec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22046",
    "data-name": "Path 22046",
    d: "M1666.818,511.325c-26.06,8.081-44.715,40.482-36.111,78.932a104.878,104.878,0,0,0,28.428,14.431c-13.37-31.43.125-59.865,21.416-65.619a89.735,89.735,0,0,1-13.733-27.743",
    transform: "translate(-1258.504 -494.141)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22047",
    "data-name": "Path 22047",
    d: "M1676.661,560.461a7.225,7.225,0,0,0-2.94,6.106c-8.605,8.353-13.839,21.548-13.113,36.907-1.552.976-2.461,3.372-1.894,6.873a72.055,72.055,0,0,0,2.606,10.713,104.593,104.593,0,0,1-13.817-7.378,81.723,81.723,0,0,1-1.822-11.779,40.326,40.326,0,0,0-2.921-11.589c1.022-17.584,8.143-32.459,18.638-42.036a8.382,8.382,0,0,0,6.911-1.385,44.4,44.4,0,0,1,9.172-4.857,90.705,90.705,0,0,0,7.359,14.126,36.47,36.47,0,0,0-8.18,4.3",
    transform: "translate(-1268.626 -516.071)",
    fill: "#d1e4f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22048",
    "data-name": "Path 22048",
    d: "M1670.691,609.443c-4.339-5.645-11.043-7.447-14.073-1.221-3.074,6.18-.023,17.124,5.438,21.793,5.458,4.755,10.22,2.436,12.186-2.773,1.952-5.292.856-12.091-3.55-17.8",
    transform: "translate(-1277.647 -560.538)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22049",
    "data-name": "Path 22049",
    d: "M1661.439,718.5c-2.178-1.785-4.27-.726-4.307,2.745s2.169,7.824,4.545,9.376,3.865-.065,3.712-3.3-1.76-7.031-3.95-8.826",
    transform: "translate(-1278.888 -641.465)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22050",
    "data-name": "Path 22050",
    d: "M1725.107,574.728c-1.425-2.4-4.353-3.351-6.439-1.58s-2.347,5.467-.724,7.743a4.086,4.086,0,0,0,6.238.759,5.424,5.424,0,0,0,.925-6.922",
    transform: "translate(-1321.559 -537.634)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22051",
    "data-name": "Path 22051",
    d: "M729.66,510.26c-29.31.657-61.2-8.145-89.752-28.125a171.335,171.335,0,0,1,11.95-30.9c23.443,18.913,50.193,27.637,74.469,28.016a147.477,147.477,0,0,0,3.333,31.014",
    transform: "translate(-552.529 -451.23)",
    fill: "#a4ccec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22052",
    "data-name": "Path 22052",
    d: "M733.314,515.758c-27.871.157-57.992-8.331-85.156-26.987a170.718,170.718,0,0,1,10.208-27.179c22.872,17.794,48.672,26.22,72.307,26.888a148.276,148.276,0,0,0,2.641,27.279",
    transform: "translate(-558.42 -458.628)",
    fill: "#88b9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22053",
    "data-name": "Path 22053",
    d: "M730.023,515.077a9.648,9.648,0,0,1-6.447-3.8,128.2,128.2,0,0,1-38.561-14.006,8.448,8.448,0,0,1-7.771-.976q-4.1-2.56-8.107-5.461-2.659,6.522-4.817,13.4,4.352,2.966,8.808,5.578a17.729,17.729,0,0,1,6.618,7.012A146.1,146.1,0,0,0,723.317,531a9.566,9.566,0,0,1,6.985-1.751q5.495.586,10.917.719-.92-7.07-1.154-14.036-4.977-.211-10.042-.853",
    transform: "translate(-569.96 -479.512)",
    fill: "#d1e4f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22054",
    "data-name": "Path 22054",
    d: "M784.055,551.986c-.4,6.395-5.479,10.646-11.9,8.661-6.41-1.964-10.9-9.484-9.549-15.877,1.335-6.409,7.225-9.3,12.688-7.35,5.473,1.978,9.151,8.141,8.758,14.566",
    transform: "translate(-639.972 -512.346)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22055",
    "data-name": "Path 22055",
    d: "M712.521,536.723c-.57,2.474-3.254,3.428-6.046,1.94s-4.493-4.831-3.752-7.287,3.5-3.118,6.12-1.656,4.247,4.522,3.678,7",
    transform: "translate(-597.259 -506.727)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22056",
    "data-name": "Path 22056",
    d: "M870.445,590.285c.078,2.463-2.073,4.244-4.912,3.834s-5.142-2.882-5.05-5.359,2.4-4.027,5.065-3.6a5.716,5.716,0,0,1,4.9,5.123",
    transform: "translate(-710.031 -546.815)",
    fill: "#004b23",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageDeliveryPriceIconImage);
export default __webpack_public_path__ + "static/media/home-page_delivery-price-icon-image.c8de46681c304c2afcecdf66bf272b02.svg";
export { ForwardRef as ReactComponent };